import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { Schedule } from './Schedule'

export interface ScheduleRouteProps {
    isFullSize: boolean
}

export const ScheduleRegistration = createRegisterableComponent(
    'stats-schedule',
    (props: ScheduleRouteProps) => {
        return <Schedule isFullSize={props.isFullSize} />
    },
)
